window.Flatspot = window.Flatspot || {};

Flatspot.sub2Trackr = (function() {
    window.__s2tQ = window.__s2tQ || []; // declare if missing

    var _pushToSub2 = function(message, payload) {
        __s2tQ.push([message, payload]);
    };
    var _sendCart = function() {
        var cartXML = '';
        $.getJSON('/cart.js', function(data) {
            cartXML = _buildCartXML(data);
            if (cartXML == '') return;
            _pushToSub2('sendBasket', cartXML);
        });
    };
    var _buildCartXML = function(cartObj) {
        var xml = '';
        var items = cartObj.items;
        var prodNodes;

        if (items.length == 0) return ''; // bailout. Nothing to do

        prodNodes = cartObj.items.map(_buildCartItem);
        xml = `<Store>${prodNodes.join('')}</Store>`;

        return xml;
    };
    var _buildCartItem = function(item) {
        var node = '';
        var size;
        var variantCount;
        var color;
        var sendColor = !0;

        size = item.variant_options[0];
        variantCount = item.variant_options.length;

        if (variantCount == 1) {
            sendColor = 0;
            if (size.toUpperCase() == 'DEFAULT TITLE') size = 'One size';
        } else {
            color = item.variant_options[1];
        }

        node += '<Product>';
        node += `<SKU>${item.sku}</SKU>`;
        node += `<Product_ID>${item.product_id}</Product_ID>`;
        node += `<Product_Name>${item.product_title}</Product_Name>`;
        node += `<Unit_Price>${item.price}</Unit_Price>`;
        node += '<Currency>GBP</Currency>';
        node += `<Quantity>${item.quantity}</Quantity>`;
        node += `<Size>${size}</Size>`;
        if (sendColor) node += `<Color>${color}</Color>`;
        node += '</Product>';

        return node;
    };
    var _sendDetails = function(obj) {
        _pushToSub2('storeData', obj);
    };
    var _sendOrderDetails = function() {};
    var _sendEmailSubscriber = function() {};
    return {
        sendCart() {
            _sendCart();
        },
        sendUserDetails(obj) {
            _sendDetails(obj);
        },
        sendOrderDetails() {
            _sendOrderDetails();
        },
        sendEmailSubscriber() {
            _sendEmailSubscriber();
        },
    };
})();
